// ---------------------------------------------------------------------------
// Theme preferences — the *type* + helpers Tailwind code reads from. The MUI
// theme this file used to build is gone; shadcn/Tailwind read colours from
// CSS variables defined in `src/index.css`, so all this file owns now is the
// preference shape, default values, and the dyslexia-mode predicate.
// ---------------------------------------------------------------------------

export interface ThemePreferences {
  mode: 'dark' | 'light' | 'system';
  highContrast: boolean;
  fontFamily: 'default' | 'dyslexia' | 'dyslexia-hc';
  fontSize: 'small' | 'medium' | 'large' | 'xl';
  reducedMotion: boolean;
}

export const defaultPreferences: ThemePreferences = {
  mode: 'dark',
  highContrast: false,
  fontFamily: 'default',
  fontSize: 'medium',
  reducedMotion: false,
};

export function isDyslexiaTheme(fontFamily: ThemePreferences['fontFamily']): boolean {
  return fontFamily === 'dyslexia' || fontFamily === 'dyslexia-hc';
}
